// extracted by mini-css-extract-plugin
export var container = "_73-0";
export var error = "_73-9";
export var label = "_73-5";
export var light = "_73-6";
export var md = "_73-3";
export var sm = "_73-2";
export var thin = "_73-8";
export var thinBold = "_73-7";
export var vertical = "_73-4";
export var xs = "_73-1";